import type { EquipSlot } from "@pd/shared";

/** Empty equipment sockets describe the slot, never stand in for item art. */
export function equipmentSlotIcon(slot: EquipSlot): string {
  const shapes: Record<EquipSlot, string> = {
    weapon: '<path d="m9 22 12-12 4-2-2 4-12 12M7 20l5 5M6 26l3-3M5 27l2 2"/>',
    shield: '<path d="m16 4 10 4v9c0 6-6 10-10 13C12 27 6 23 6 17V8Z"/><path d="M16 8v17M10 13h12"/>',
    helmet: '<path d="M6 24V14a10 10 0 0 1 20 0v10l-6 4H12Z"/><path d="M16 4v9M7 15h18M12 19v4M20 19v4"/>',
    chest: '<path d="m10 5 6 3 6-3 7 7-5 5-3-3v14H11V14l-3 3-5-5Z"/><path d="m12 9 4 3 4-3M12 24h8"/>',
    legs: '<path d="M9 4h14l2 24h-7l-2-14-2 14H7Z"/><path d="M9 9h14M16 5v6"/>',
    feet: '<path d="M6 5h8v12l3 4v6H4v-7l2-3Zm14 0h8v12l2 4v6H19v-7l1-3Z"/><path d="M6 10h8M20 10h8M4 24h13M19 24h11"/>',
  };
  return `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${shapes[slot]}</svg>`;
}
